import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { func, string, shape } from 'prop-types'
import { generateTripDetails } from '../BookingInformation/utilities'
import appRoutes from '../../configuration/appRoutes'
import { clearTicketNumbers, clearReceipts } from '../../redux/booking/actions'
import {
  selectBookingState
  // selectReceipts
} from '../../redux/booking/selectors'
import { formatPriceByLanguage } from '../../redux/configuration/utilities'
import { clearActiveModifyBooking } from '../../redux/modifyBooking/actions'
// import { fetchPaymentConfirmation } from '../../redux/paymentConfirmation/actions'
// import { selectPaymentConfirmationState } from '../../redux/paymentConfirmation/selectors'
import {
  selectAccommodationsContent,
  selectVehicleViewContent
} from '../../redux/configuration/selectors'
import dateFormats from '../../configuration/dateFormats'
import { ENABLE_CHASE_CHECKOUT } from '../../configuration/constants'
import { findReservation } from '../../api/api'
import moment from 'moment'
import { normalizeLabelWithCount } from '../../configuration/utilities'
import BookingConfirmationTable from '../BookingConfirmation/BookingConfirmationTable'
import BrandLoader from '../BrandLoader/BrandLoader'
import BookingConfirmationList from '../BookingConfirmationList/BookingConfirmationList'
import { selectActiveModifyBooking } from '../../redux/modifyBooking/selectors'
import { useHistory, useLocation } from 'react-router-dom'

const ChaseCheckoutConfirmationContainer = ({
  lang,
  labels,
  handleRouteChange,
  bookingConfirmationData,
  isTelephoneBooking,
  ferryId
}) => {
  const bookingData = useSelector(selectBookingState)
  const vehicleContent = useSelector(selectVehicleViewContent)
  const accommodationsContent = useSelector(selectAccommodationsContent)
  // const paymentConfirmationState = useSelector(selectPaymentConfirmationState)
  // const receipts = useSelector(selectReceipts)

  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const [paymentSuccess, setPaymentSuccess] = useState(false)
  const [loadingReceipts, setLoadingReceipt] = useState(false)
  const [loadingDetails, setLoadingDetails] = useState(false)
  const [bookingDetails, setBookingDetails] = useState(null)
  const [showSuccessTable, setShowSuccessTable] = useState(false)
  const [summary, setSummary] = useState(null)
  const [departureAccommodations, setDepartureAccommodations] = useState([])
  const [returnAccommodations, setReturnAccommodations] = useState([])
  const activeModifyBooking = useSelector(selectActiveModifyBooking)
  const data = bookingData?.data
  const bookingNumber = bookingConfirmationData?.bookingNumber
  const formatForLang =
    lang === 'fr'
      ? dateFormats.summaryTableLongDisplayFrench
      : dateFormats.summaryTableLongDisplay

  // Note: get receipt success reducer replaces all previous receipts with 1 new receipt
  // const receipt = receipts && Object.values(receipts)?.[0]
  // const [error, setError] = useState(null)
  const [
    eCommercePurchaseEventTriggered,
    setECommercePurchaseEventTriggered
  ] = useState(false)

  // we pass this on a successful moneris checkout payment.
  // it is used by dolli to link payments to bookings

  const clientId = process.env.REACT_APP_FLOW_CLIENT_ID
  const tripDetails = generateTripDetails({
    ...bookingConfirmationData,
    lang,
    labels,
    mapToEcommerceEvent: true
  })

  // eCommercePurchaseEvent
  useEffect(() => {
    if (
      tripDetails &&
      bookingConfirmationData?.bookingNumber &&
      !eCommercePurchaseEventTriggered
    ) {
      setECommercePurchaseEventTriggered(true)
    }
  }, [
    clientId,
    bookingConfirmationData,
    tripDetails,
    labels,
    lang,
    eCommercePurchaseEventTriggered
  ])

  // useEffect(() => {
  //   if (!receipt) {
  //     setError(labels.paymentDeclinedError)
  //   } else {
  //     const reqBody = {
  //       bookingNumber: bookingConfirmationData?.bookingNumber,
  //       isPhonePayment: (!!isTelephoneBooking).toString(),
  //       currencyType: bookingConfirmationData?.bookingCurrency,
  //       orderId: receipt?.orderId,
  //       cardType: receipt?.cardType,
  //       amount: receipt?.amount,
  //       approvalCode: receipt?.authorizationCode,
  //       token: receipt?.safetechToken,
  //       transactionNumber: receipt?.txRefNum,
  //       ferryId,
  //       paymentProvider: 'Chase',
  //       safetechToken: receipt?.safetechToken,
  //       safetechTokenExpiryDate: receipt?.expYear + receipt?.expMonth,
  //       cardBrandForOrbital: receipt?.cardType,
  //       ticketNumber: receipt?.id
  //     }

  //     if (
  //       !paymentConfirmationState.loading &&
  //       !paymentConfirmationState.data &&
  //       !error
  //     ) {
  //       dispatch(fetchPaymentConfirmation(reqBody))
  //     }
  //   }
  // }, [receipt]) // eslint-disable-line react-hooks/exhaustive-deps

  // TODO: restore ecommerce event

  const tableData = ENABLE_CHASE_CHECKOUT
    ? [
        {
          label: labels.bookingNumber,
          value: bookingNumber
        },
        {
          label: labels.transactionStatus,
          value:
            bookingNumber && paymentSuccess
              ? labels['paymentStatusPaid']
              : labels['paymentStatusUnpaid']
        }
      ]
    : [
        {
          label: labels.bookingNumber,
          value: bookingData?.data?.bookingNumber
        },
        {
          label: labels.transactionStatus,
          value: labels[data?.paymentStatus]
        },
        {
          label: labels.bookingStatus,
          value: labels[data?.bookingStatus]
        }
      ]

  if (data?.refundApplied) {
    tableData.push({
      label: labels.totalRefund,
      value: formatPriceByLanguage(data?.refundAmount, lang)
    })
  }

  const fireAnalytics = (bookingSource = 'Online') => {
    try {
      const storageKey = 'ga4_fired_list'
      let list = []
      try {
        list = JSON.parse(localStorage.getItem(storageKey)) || []
      } catch (err) {
        list = []
      }

      if (list.includes(bookingNumber) || activeModifyBooking) return

      const ecommerceTripDetails = generateTripDetails({
        ...bookingConfirmationData,
        lang,
        labels,
        mapToEcommerceEvent: true,
        bookingSource
      })

      if (!ecommerceTripDetails?.products?.length) return

      window.dataLayer = window?.dataLayer || []
      window.dataLayer.push({
        event: 'analytics-confirmation-1',
        details: ecommerceTripDetails
      })
      list.push(bookingNumber)
      localStorage.setItem(storageKey, JSON.stringify(list))
    } catch (err) {
      console.log('Analytics error: ' + err)
    }
  }

  useEffect(() => {
    const isPaymentSuccess = !!location.state?.paymentSuccess
    if (isPaymentSuccess) {
      setPaymentSuccess(true)
      history.replace({
        pathname: location.pathname,
        search: location.search,
        state: null
      })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // preventing go back to payment page
  useEffect(() => {
    const unlisten = history.listen((_, action) => {
      if (action === 'POP') {
        dispatch(clearActiveModifyBooking())
        dispatch(clearTicketNumbers())
        dispatch(clearReceipts())
        history.replace(appRoutes.ferryRoutes.pathname)
      }
    })
    return () => unlisten()
  }, [history, dispatch])

  useEffect(() => {
    if (
      paymentSuccess &&
      bookingNumber &&
      bookingData &&
      !bookingDetails &&
      !loadingDetails
    ) {
      setLoadingDetails(true)
      async function getBookingDetails({
        workPhoneNumber,
        email,
        reservationId
      }) {
        const reservationData = await findReservation({
          workPhoneNumber,
          email,
          reservationId
        }).catch(err => {
          console.error(`Could not get reservation data`, err)
        })
        let bookingData =
          reservationData?.data?.['hydra:member']?.[0]?.bookingReservation

        if (!bookingData) {
          if (bookingNumber) {
            fireAnalytics(isTelephoneBooking ? 'Telephone' : 'Online')
          }
          bookingData = data
          // setLoadingDetails(false)
          // setShowSuccessTable(true)
          // return
        } else {
          fireAnalytics('Online')
        }

        const summaryDepartureDate = moment(
          new Date(`${bookingData.departureDate}T00:00:00`)
        ).format(formatForLang)
        const summaryArrivalDate = bookingData?.arrivalDate
          ? moment(new Date(`${bookingData.arrivalDate}T00:00:00`)).format(
              formatForLang
            )
          : null
        const ferrySummary = {
          icon: 'routes',
          label: `${labels[bookingData?.departures?.[0]?.routeCode]} | ${
            bookingData?.departures?.length > 1 ? labels.return : labels.oneWay
          }`,
          date: `${summaryDepartureDate}${
            summaryArrivalDate ? ` - ${summaryArrivalDate}` : ''
          }`,
          grandTotal: formatPriceByLanguage(
            Number(bookingData?.reservationTotals?.totalPriceToPay),
            lang
          ),
          discount:
            Number(bookingData?.reservationTotals?.discount) > 0
              ? formatPriceByLanguage(
                  Number(bookingData?.reservationTotals?.discount),
                  lang
                )
              : null
        }

        const departureAccommodationsData = []
        const returnAccommodationsData = []

        const ferryData =
          bookingData?.departures?.map((departure, key) => {
            const subheader =
              key === 0
                ? labels.departure || 'label:departure'
                : labels.return || 'label:return'
            const departureDate = moment(
              new Date(`${departure.departureDate}T00:00:00`)
            ).format(formatForLang)
            const arrivalDate = moment(
              new Date(`${departure.arrivalDate}T00:00:00`)
            ).format(formatForLang)
            const departureTimes = `${labels.departure} ${departure.departureTime} → ${labels.arrival} ${departure.arrivalTime}`
            const vehicles =
              departure.vehicles?.booked?.length > 0
                ? departure.vehicles?.booked
                    ?.map(vehicle => {
                      const vehicleIconData = vehicleContent?.vehicleGrouping?.[0]?.icons?.find(
                        vehicleType =>
                          vehicleType.resourceCode === vehicle.resourceCode
                      )
                      return vehicleIconData?.default || null
                    })
                    .filter(Boolean)
                : []
            const passengersLookup = {}

            const passengerTotal = departure.passengerPriceLines.reduce(
              (total, passenger) => (total += +passenger.price),
              0
            )
            const passengerFees = departure.passengerAddonPriceLines.reduce(
              (total, addon) => (total += +addon.price),
              0
            )
            const vehicleTotal = departure.vehiclePriceLines.reduce(
              (total, vehicle) => (total += +vehicle.price),
              0
            )
            const vehicleFees = departure.vehicleAddonPriceLines.reduce(
              (total, addon) => (total += +addon.price),
              0
            )
            const ammendmentFees = departure.amendmentFeePriceLines.reduce(
              (total, fee) => (total += +fee.price),
              0
            )
            const addons = departure.addOnPriceLines.reduce(
              (total, addon) => (total += +addon.price),
              0
            )

            const departureMinusAccommsTotal =
              passengerTotal +
              passengerFees +
              vehicleTotal +
              vehicleFees +
              ammendmentFees +
              addons

            departure.passengers.booked.forEach(passenger => {
              const curPassengerCount =
                passengersLookup?.[passenger.passengerType]
              if (curPassengerCount) {
                passengersLookup[passenger.passengerType] += 1
              } else {
                passengersLookup[passenger.passengerType] = 1
              }
            })
            const guestList = Object.entries(passengersLookup)
              .map(([key, count]) => {
                let pluralKey
                switch (key) {
                  case 'A':
                    pluralKey = 'adults'
                    break
                  case 'S':
                    pluralKey = 'seniors'
                    break
                  case 'C':
                    pluralKey = 'children'
                    break
                  case 'ST':
                    pluralKey = 'students'
                    break
                  case 'I':
                    pluralKey = 'infants'
                    break
                  case 'PET':
                    pluralKey = 'pets'
                    break
                  default:
                    pluralKey = ''
                    break
                }

                const guestLabel = normalizeLabelWithCount({
                  labelKey: `passengerType${key}`,
                  pluralLabelKey: pluralKey,
                  lang,
                  count,
                  labels,
                  showCountWhenOne: true
                })

                return `${guestLabel}`
              })
              .join(', ')

            departure.accommodationPriceLines.forEach(accomm => {
              const cabinLabel = normalizeLabelWithCount({
                labelKey: 'selectedServicesLineItem',
                pluralLabelKey: 'selectedServicesLineItemPlural',
                lang,
                number: Number(accomm.number),
                labels,
                showCountWhenOne: true
              })
              const accommData = {
                id: accomm.resourceCode,
                icon: 'accommodations',
                label: `${
                  accommodationsContent?.accommodations?.[accomm.resourceCode]
                    .caption
                } | ${cabinLabel}`,
                date: `${departureDate} - ${arrivalDate}`,
                price: formatPriceByLanguage(
                  +accomm.price + +accomm.tax + +accomm.tax2,
                  lang
                )
              }
              if (key === 0) {
                departureAccommodationsData.push(accommData)
              } else {
                returnAccommodationsData.push(accommData)
              }
            })

            return {
              subheader: subheader,
              value: departureDate,
              date: departureTimes,
              vehicles: vehicles,
              passengers: guestList,
              price: formatPriceByLanguage(+departureMinusAccommsTotal, lang)
            }
          }) || []

        setDepartureAccommodations(departureAccommodationsData)
        setReturnAccommodations(returnAccommodationsData)
        setSummary(ferrySummary)
        setBookingDetails(ferryData)
        setLoadingDetails(false)
        setShowSuccessTable(false)
      }
      // if (receipt.merchantData1 || receipt.merchantData3) {
      //   getBookingDetails({
      //     email: receipt.merchantData1 || '',
      //     reservationId: bookingNumber,
      //     workPhoneNumber: receipt.merchantData3 || ''
      //   })
      // }
      if (data?.address?.email || data?.address?.workPhoneNumber) {
        getBookingDetails({
          email: data?.address?.email || '',
          reservationId: bookingNumber,
          workPhoneNumber: data?.address?.workPhoneNumber || ''
        })
      } else {
        setShowSuccessTable(true)
        setLoadingDetails(false)
        if (bookingNumber) {
          fireAnalytics(isTelephoneBooking ? 'Telephone' : 'Online')
        }
      }
      setLoadingReceipt(false)
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingReceipts, bookingData, paymentSuccess])

  const renderCTAs = () => (
    <div className="booking-confirmation__submits">
      <button
        className="btn btn-primary large-primary-btn"
        onClick={() => {
          dispatch(clearActiveModifyBooking())
          dispatch(clearTicketNumbers())
          dispatch(clearReceipts())
          handleRouteChange(appRoutes.ferryRoutes.pathname)
        }}
      >
        {labels.newBookingBtn || labels.continueBtn}
      </button>
      <button
        className="btn btn-primary large-primary-btn"
        onClick={() => {
          dispatch(clearActiveModifyBooking())
          dispatch(clearTicketNumbers())
          dispatch(clearReceipts())
          handleRouteChange(appRoutes.account.pathname)
        }}
      >
        {labels.myAccountBtn}
      </button>
    </div>
  )

  if (
    showSuccessTable ||
    data?.refundApplied ||
    !bookingNumber ||
    !paymentSuccess
  ) {
    return (
      <div className="booking-confirmation">
        <div className="u-container">
          <div className="booking-confirmation-content">
            <div className="booking-confirmation-container">
              <h2 className="theme-font-header booking-success-header">
                {labels.bookingConfirmtion}
              </h2>
              <BookingConfirmationTable
                headerLabel={
                  bookingNumber && paymentSuccess
                    ? labels.transactionApproved
                    : labels.transactionCancelled
                }
                tableData={tableData}
                centerHeader={true}
              />
            </div>
            {renderCTAs()}
          </div>
        </div>
      </div>
    )
  }

  if (bookingNumber && !bookingDetails) {
    return (
      <div className="booking-confirmation">
        <div className="u-container">
          <div className="booking-confirmation-content">
            <div className="booking-confirmation-container">
              <h2 className="theme-font-header booking-success-header">
                {labels.bookingConfirmtion}
              </h2>
              <BrandLoader />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="booking-confirmation">
      <div className="u-container">
        <div className="booking-confirmation-content">
          <div className="booking-confirmation-container">
            <h2 className="theme-font-header booking-success-header">
              {labels.bookingConfirmtion}
            </h2>
            <h3 className="theme-font-subheader booking-success-subheader">
              {bookingNumber
                ? labels.transactionApproved
                : labels.transactionCancelled}
            </h3>

            <div className="booking-success-number">
              <span className="booking-success-number__label">
                {labels.yourBookingNumber || 'label:yourBookingNumber'}:
              </span>
              <span className="booking-success-number__value">
                {bookingNumber}
              </span>
            </div>
            {labels.bookingSuccessDisclaimer ? (
              <div
                className="booking-success-disclaimer"
                dangerouslySetInnerHTML={{
                  __html: labels.bookingSuccessDisclaimer
                }}
              />
            ) : (
              <div className="booking-success-disclaimer">
                label:bookingSuccessDisclaimer (HTML Enabled)
              </div>
            )}

            <h3 className="booking-success-summary-header">
              {labels.bookingSummary || 'label:bookingSummary'}
            </h3>
            <div className="booking-success-breakdown">
              <BookingConfirmationList
                listData={bookingDetails || []}
                summary={summary}
                centerHeader
                headerLabel={labels.ferryTravel || 'label:ferryTravel'}
                labels={labels}
                id="summary"
              />
              {departureAccommodations?.length > 0 &&
                departureAccommodations.map((accommodation, idx) => (
                  <BookingConfirmationList
                    listData={[]}
                    summary={accommodation}
                    centerHeader
                    headerLabel={
                      idx === 0
                        ? labels.accommodations || 'label:accommodations'
                        : null
                    }
                    labels={labels}
                    id={`departure-accomm-${idx}`}
                  />
                ))}
              {returnAccommodations?.length > 0 &&
                returnAccommodations.map((accommodation, idx) => (
                  <BookingConfirmationList
                    listData={[]}
                    summary={accommodation}
                    headerLabel={null}
                    labels={labels}
                    id={`return-accomm-${idx}`}
                  />
                ))}
              {summary?.discount && (
                <div className="booking-success-grand-total">
                  <span className="booking-success-grand-total__label">
                    {labels.discounts || 'label:discounts'}:
                  </span>
                  <span className="booking-success-grand-total__value">
                    {summary.discount}
                  </span>
                </div>
              )}
              {summary?.grandTotal && (
                <div className="booking-success-grand-total">
                  <span className="booking-success-grand-total__label">
                    {labels.grandTotal || 'label:grandTotal'}:
                  </span>
                  <span className="booking-success-grand-total__value">
                    {summary.grandTotal}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        {renderCTAs()}
      </div>
    </div>
  )
}

ChaseCheckoutConfirmationContainer.propTypes = {
  lang: string.isRequired,
  labels: shape().isRequired,
  handleRouteChange: func.isRequired,
  bookingConfirmationData: shape().isRequired,
  ferryId: string.isRequired
}

export default ChaseCheckoutConfirmationContainer
